export default __webpack_public_path__ + "static/media/number-shine-5.a5b2e9b9.svg";